import { useEffect, useState } from "react";
import { AiSettingsPanel } from "./AiSettingsPanel";
import type { AiGatewayClient } from "./client";
import { DEFAULT_AI_RUNTIME_SETTINGS, type AiRuntimeSettings } from "./settings";

interface AiSettingsGatewayPanelProps {
  client: AiGatewayClient;
}

export function AiSettingsGatewayPanel({ client }: AiSettingsGatewayPanelProps) {
  const [settings, setSettings] = useState<AiRuntimeSettings>(DEFAULT_AI_RUNTIME_SETTINGS);
  const [domainVersion, setDomainVersion] = useState(0);
  const [ready, setReady] = useState(false);
  const [loadFailed, setLoadFailed] = useState(false);

  useEffect(() => {
    let cancelled = false;

    void client
      .readSettings()
      .then((state) => {
        if (cancelled) return;
        setSettings(state.settings);
        setDomainVersion(state.domainVersion);
        setLoadFailed(false);
        setReady(true);
      })
      .catch(() => {
        if (cancelled) return;
        setLoadFailed(true);
        setReady(false);
      });

    return () => {
      cancelled = true;
    };
  }, [client]);

  if (loadFailed) {
    return (
      <section className="section-card" aria-live="polite">
        <p className="settings-warning">خواندن تنظیمات امن هوش مصنوعی ناموفق بود.</p>
      </section>
    );
  }

  return (
    <AiSettingsPanel
      value={settings}
      backendReady={ready}
      onSave={async (input) => {
        const nextVersion = await client.saveSettings(input, domainVersion);
        const refreshed = await client.readSettings();
        setSettings(refreshed.settings);
        setDomainVersion(Math.max(nextVersion, refreshed.domainVersion));
      }}
      onTest={() => client.testProvider()}
    />
  );
}
